import React from 'react';
import { insidePages } from '../data/content';

// Desktop: offsets verticales alternos para dar ritmo editorial sin superponer contenido.
const desktopOffsets = ['md:translate-y-0', 'md:translate-y-10', 'md:translate-y-0'];
export function InsidePages() {
  return <section className="overflow-hidden bg-cream-deep py-16 sm:py-20" aria-labelledby="inside-title" data-id="element-125" data-mp="2e8uihrprvlqz">
      <div className="mx-auto max-w-[880px] px-5 text-center sm:px-8" data-id="element-126" data-mp="35y62d7562fii">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-terra" data-id="element-127" data-mp="35xe4fpo3k5p2">Mira el material por dentro</p>
        <h2 id="inside-title" className="mt-4 text-balance font-display text-[2.1rem] leading-tight text-petrol sm:text-5xl" data-id="element-128" data-mp="31yote3qj708l">
          Esto es parte de lo que <em className="text-terra" data-id="element-129" data-mp="2s5pvfv959xcb">encontrarás dentro</em>
        </h2>
      </div>

      {/* Mobile: carrusel horizontal */}
      <ul className="mt-10 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-4 [scrollbar-width:none] md:hidden [&::-webkit-scrollbar]:hidden" aria-label="Páginas interiores (desliza para ver más)" data-id="element-130" data-mp="3pnq09mjpu3br">
        {insidePages.map(p => <li key={p.src} className="w-[78%] shrink-0 snap-center" data-id="element-131" data-mp="1rlp8k83qsjo5">
            <img src={p.src} alt={p.alt} width={1191} height={1684} loading="lazy" className="block h-auto w-full rounded-lg shadow-soft ring-1 ring-black/5" data-id="element-132" data-mp="1du0uhz9xnl4j" />
          </li>)}
      </ul>

      {/* Desktop: cuadrícula editorial de 3 columnas; la última fila queda centrada */}
      <ul className="mx-auto mt-14 hidden max-w-[1040px] flex-wrap justify-center gap-7 px-8 pb-10 md:flex" data-id="element-133" data-mp="18sv262k6pzvj">
        {insidePages.map((p, i) => <li key={p.src} className={`w-[calc((100%-3.5rem)/3)] ${desktopOffsets[i % 3]}`} data-id="element-134" data-mp="yw06drfaqdky" data-mpi={i}>
            <img src={p.src} alt={p.alt} width={1191} height={1684} loading="lazy" className="block h-auto w-full rounded-lg shadow-soft ring-1 ring-black/5" data-id="element-135" data-mp="2p8xyqgeougwh" />
          </li>)}
      </ul>
    </section>;
}